  import profilePhoto from "../Assets/profile-photo.jpeg";

  export const profile = {
    name: "Adithya Reddy Geeda",
    titles: ["Data Scientist", "ML Engineer", "MS Engineering Data Science"],
    bio: [
      "I'm an MS in Engineering Data Science candidate at the University of Houston (May 2026), with a BTech in Computer Science (AI) from SRM University.",
      "I build systems across machine learning, deep learning, NLP, and computer vision—from brain tumor detection and multilingual NLU to video action recognition and LLM-powered recommendation engines.",
      "Experienced in TensorFlow, PyTorch, prompt engineering, and end-to-end ML pipelines (Streamlit, Gradio, Flask). Ready to collaborate on AI/ML research and data-driven products.",
    ],
    image: profilePhoto,
    social: {
      email: "adithyareddygeeda@gmail.com",
      linkedin: "https://www.linkedin.com/in/adithya-reddy-geeda/",
      github: "https://github.com/AdithyaReddyGeeda",
    },
  };
